import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
// import { UserHeader } from "../components/UserHeader";
import { ChildForms } from "../components/children/ChildForms";
import { ChildFormsAnalyst } from "../components/children/ChildFormsAnalyst";
import styles from "./css/ChildDetails.module.css";
import { safeLogger } from "../utils/logger";

export const ChildFormsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state: RootState) => state.auth.user);
  const [childName, setChildName] = useState(location.state?.childName || "");
  const [childCode, setChildCode] = useState<number | null>(null);

  useEffect(() => {
    // אם אין שם או קוד ילד מהניווט, נטען מהשרת
    if ((!childName || !childCode) && id) {
      fetch(`/api/child/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
        .then(res => res.json())
        .then(data => {
          setChildName(`${data.fname} ${data.lname}`);
          setChildCode(data.code);
        })
        .catch(() => {
          setChildName("שם הילד");
          setChildCode(Number(id));
          safeLogger.error("Failed to load child details");
        });
    } else if (id && !childCode) {
      setChildCode(Number(id));
    }
  }, [childName, childCode, id]);

  return (
    <>
      {/* <UserHeader /> */}
      <div className={styles.pageContainer}>
        <div className={styles.container}>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '15px'
          }}>
            {/* הכפתור חזרה לפרטי הילד הוסר */}
            <div></div> {/* Placeholder for flex alignment */}
          </div>

          <h2 className={styles.childName}>{childName} - טפסים</h2>

          {childCode ? (
            // אם המשתמש הוא מנתחת - הצג גרסת צפייה בלבד עם סינון
            user?.role === "Analyst" ? (
              <ChildFormsAnalyst childId={childCode} childName={childName} />
            ) : (
              // אם המשתמש הוא הורה - הצג גרסה מלאה עם עריכה
              <ChildForms childId={childCode} childName={childName} />
            )
          ) : (
            <div style={{ textAlign: 'center', padding: '30px' }}>טוען נתונים...</div>
          )}
        </div>
      </div>
    </>
  );
};
